module.exports = __webpack_public_path__ + "static/media/ashadv.fdac4a77.jpeg";